import * as React from "react";
const SvgFiRrPersonCv = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-person-cv_svg__a)">
      <path
        fill="#062147"
        d="M21 12h-9a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3m-7.5 8.4a.9.9 0 0 0 .866-.653c.022-.079.068-.747.835-.747s.811.705.799.804A2.52 2.52 0 0 1 13.5 22a2.5 2.5 0 0 1-2.5-2.5v-3a2.5 2.5 0 0 1 2.5-2.5c1.281 0 2.354.963 2.5 2.204.011.097.002.796-.804.796s-.809-.674-.833-.755a.901.901 0 0 0-1.763.255v3c0 .496.404.9.9.9m7.506.025c-.126.647-.583 1.575-1.628 1.575s-1.51-.97-1.618-1.531l-1.072-5.253a.8.8 0 0 1 1.568-.32l1.072 5.253a.7.7 0 0 0 .05.159 1 1 0 0 0 .057-.188l1.053-5.222a.8.8 0 1 1 1.568.316l-1.051 5.211zM14 6c0-3.309-2.691-6-6-6S2 2.691 2 6s2.691 6 6 6 6-2.691 6-6m-6 4c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m-1.042 5.005a1 1 0 0 1-.673 1.243C3.762 16.999 2 19.364 2 22v1a1 1 0 1 1-2 0v-1c0-3.514 2.35-6.667 5.715-7.668a1 1 0 0 1 1.243.673"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-person-cv_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPersonCv;
